import styled, { keyframes } from 'styled-components';

interface ProgressFillerProps {
    $progress: number;
}

interface StyleProps {
    $textColor: string;
}

interface IconProps extends StyleProps {
    $isAnimated: boolean;
}

export const spin = keyframes`
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
`;

export const syncShimmer = keyframes`
    0% { background-position: 200% 0; }
    100% { background-position: 0 0; }
`;

export const SCBannerTopRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

export const SCClearButton = styled.button<StyleProps>`
    background: transparent;
    border: 1px solid ${(props) => props.$textColor};
    color: ${(props) => props.$textColor};
    padding: 6px 14px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    cursor: pointer;
    opacity: 0.8;
    transition: all 0.2s ease-in-out;

    &:hover {
        opacity: 1;
        background-color: ${(props) => props.$textColor}1a; 
    }

    &:active {
        transform: scale(0.97);
    }
`;

export const SCIconWrapper = styled.div<IconProps>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${(props) => props.$textColor};
    margin-right: 8px;
    
    svg {
        animation: ${(props) => (props.$isAnimated ? spin : 'none')} 2s linear infinite;
    }
`;

export const SCRefreshButton = styled.button<StyleProps>`
    background: transparent;
    border: 1px solid ${(props) => props.$textColor}40;
    color: ${(props) => props.$textColor};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    border-radius: 6px;
    cursor: pointer;
    margin-right: 8px;
    transition: all 0.2s ease-in-out;

    &:hover {
        border-color: ${(props) => props.$textColor};
        background-color: ${(props) => props.$textColor}1a;
    }

    &:active {
        transform: scale(0.92);
    }
`;

export const SCProgressWrapper = styled.div`
    width: 100%;
    margin-top: 16px;
`;

export const SCProgressLabels = styled.div`
    display: flex; 
    justify-content: space-between; 
    align-items: center;
    font-size: 13px;
    font-weight: 500;
    opacity: 0.9;
`;

export const SCStatusGroup = styled.div`
    display: flex; 
    align-items: center;
`;

export const SCStatusText = styled.span`
    font-weight: 600;
`;

export const SCProgressTrack = styled.div`
    width: 100%;
    height: 8px; 
    background-color: rgba(0, 0, 0, 0.08); 
    border-radius: 9999px;
    overflow: hidden; 
    margin-top: 8px;
`;

export const SCProgressFiller = styled.div<ProgressFillerProps>`
    height: 100%; 
    width: ${(props) => props.$progress || 0}%;
    background: linear-gradient(90deg, #32a852 0%, #1ed959 50%, #32a852 100%); 
    background-size: 200% 100%;
    border-radius: 9999px;
    transition: width 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    animation: ${syncShimmer} 2.5s infinite linear;
`;